import { Input, Text, useIntl } from 'platform-components';
import { INPUT_SIZES, INPUT_THEMES } from 'platform-components/constants';
import React from 'react';

import { SchoolData } from '../typings';

interface Props {
    schoolData: SchoolData;
    canChangeData: boolean;
}

export const CertificateModalSchool = ({
    schoolData: { handleSchoolChange, handleValidateSchool, school, schoolErrorMessage },
    canChangeData,
}: Props) => {
    const intl = useIntl();

    return (
        <>
            <Input
                disabled={!canChangeData}
                errorMessage={schoolErrorMessage}
                mix="certificate-modal__form-field"
                onBlur={handleValidateSchool}
                onChange={handleSchoolChange}
                placeholder={intl.formatMessage({ id: 'certificatesModal.form.school' })}
                size={INPUT_SIZES.XL}
                theme={INPUT_THEMES.YANDEX}
                valid={schoolErrorMessage ? 'no' : 'uncertain'}
                value={school}
            />
            <div className="certificate-modal__form-subscription">
                <Text id="certificatesModal.form.school.description" size={Text.SIZE.S} />
            </div>
        </>
    );
};
